const url = 'https://api.dicebear.com/7.x/initials/svg';

export const getInitialsAvatar = (seed: string) => `${url}?seed=${seed}`;
